import type { TimelineMeta } from './agreementTimeline.types';

/** The dropdown's fixed choices. `other` reveals a free-text field, and the typed
 *  value is what reaches the API — `relationship` stays free text on the wire. */
export const RELATIONSHIP_OPTIONS = ['spouse', 'partner', 'parent', 'child', 'sibling', 'other'] as const;
export type RelationshipOption = (typeof RELATIONSHIP_OPTIONS)[number];

export interface AuthorisedContact {
    id: string;
    name: string;
    relationship: string;
    status: 'active' | 'revoked';
    createdAt: string;
    revokedAt: string | null;
}

export interface AuthorisedContactsPage {
    contacts: AuthorisedContact[];
    meta: TimelineMeta;
}

export interface AddAuthorisedContactInput {
    name: string;
    relationship: string;
}
